import React from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';

import { usePromoModel } from '../../../../../../contexts/PromoModelProvider';

export const NumProducts = ({ actionable }) => {
  const { itemCount } = usePromoModel();
  const numProductsClassNames = classNames({
    'u__default-link': actionable
  });

  return (
    <span className={numProductsClassNames} type="button" data-testid="promo-num-products">
      ({itemCount > 50 ? '50+' : itemCount}&nbsp;item{itemCount > 1 ? 's' : ''})
    </span>
  );
};

NumProducts.displayName = 'NumProducts';

NumProducts.propTypes = {
  actionable: bool,
};

NumProducts.defaultProps = {
  actionable: true
};
